import { UtilsService } from '../../../../services/utils.service';
import { Category } from '../../../generics/data-printer/data-printer.component';
import { Service } from '../../../../models/service.model';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-service-details-content',
    templateUrl: './service-details-content.component.html',
    styleUrls: ['./service-details-content.component.scss']
})
export class ServiceDetailsContentComponent implements OnInit {

    private serviceContent?: Service;
    @Input()
    set service(pr: Service) {
        this.serviceContent = pr;
        this.updateCategories();
    }
    get service() {
        return this.serviceContent;
    }

    categories: Category[] = [];

    constructor(
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
    }

    updateCategories() {
        if (!this.service) return;
        this.categories = [
            {
                name: 'Información general', items: [
                    { label: 'Nombre del servicio', value: this.service.nombre },
                    { label: 'Código', value: this.service.codigo },
                    { label: 'Descripción', value: this.service.descripcion },
                    { label: 'Porcentaje default', value: this.service.porcentajeDefault, type: 'percent' },
                    { label: 'Tope mínimo default', value: this.service.topeMinimoDefault, type: 'money' },
                    { label: 'Tope máximo default', value: this.service.topeMaximoDefault, type: 'money' },
                    { label: 'Depende de', value: this.service.pagador },
                    { label: 'Tipo de producto', value: this.service.tipoProducto, type: 'text' },
                ]
            }
        ];
    }

}
